import * as React from 'react';
import ouiStyle from '@goldwasserexchange/oui-style';
import { Accounts } from '../../../enum';
import { ArDocModalWithToggle } from '../../../../shared';
import { useAccountHistoryArDocHasFileName, useAccountHistoryArDocId } from '../../hooks';

export const AccountsHistoryArDocFileName = (props: {
  size?: string | number | undefined,
  transform?: ouiStyle.InStyle['transform'],
  color?: ouiStyle.Constants.Colors,
}) => {
  const {
    size,
    transform,
    color,
  } = props;
  const {
    data: hasFileName,
    isLoading,
  } = useAccountHistoryArDocHasFileName();
  const { data: arDocId } = useAccountHistoryArDocId();
  return (
    <ArDocModalWithToggle
      service={Accounts.History}
      hasFileName={hasFileName}
      isLoading={isLoading}
      arDocId={arDocId}
      size={size}
      transform={transform}
      color={color}
    />
  );
};
